import styled from 'styled-components'
import {Container, Spinner, Button} from 'reactstrap'
import {down, up} from 'styled-breakpoints'
import Youtube from 'react-youtube'
import is from 'styled-is'

import {colors} from '~/constants/style'
import {withInnerWrapper, omitProps} from '~/hocs'

const Details = styled.div``

Details.AdminZone = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 45px;
  z-index: 1;
`

const squareBtn = `
  width: 45px;
  height: 45px;
`

Details.UpBtn = styled(Button).attrs({
  children: 'Up',
})`
  ${squareBtn}
  border-radius: 0;
`

Details.EditBtn = styled.a.attrs({children: 'Sửa'})`
  ${squareBtn}
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.green};
  color: white;
`

Details.Slider = styled.div`
  height: 100%;
  background: ${colors.gray};

  ${up('md')} {
    margin-left: -15px;
    margin-right: -15px;
  }
`

Details.Brief = styled(
  omitProps('loading')('div'),
)`
  height: 100%;
  background: #dee5ea;
  padding: 40px;

  ${is('loading')`
    position: relative;
  `}

  ${up('md')} {
    margin-left: -15px;
    margin-right: -15px;
  }

  ${down('sm')} {
    padding: 30px 15px;
  }
`

Details.BriefLoadingOverlay = styled(
  withInnerWrapper(Spinner, 'color')('div'),
).attrs({color: 'dark'})`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`

Details.Name = styled.h1`
  font-size: 2rem;
`

Details.BriefTopItemsWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 30px;

  ${up('md')} {
    display: flex;
    justify-content: space-between;
  }
`

Details.BriefTopItem = styled.div`
  > svg {
    color: ${colors.green};
    margin-right: 5px;
  }

  ${up('md')} {
    &:last-child {
      text-align: right;
    }
  }

  ${down('sm')} {
    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
`

Details.Price = styled.div`
  font-size: 3rem;
  color: ${colors.green};
  margin-bottom: 30px;
`

Details.BriefContent = styled.div`
  margin-bottom: 30px;
`

Details.BriefBottomItemsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

Details.BriefBottomItem = styled.div`
  > span {
    font-weight: bold;
  }
`

Details.Main = styled(
  withInnerWrapper(Container)('div'),
)`
  padding-top: 50px;
  padding-bottom: 50px;
`

Details.Section = styled.div`
  margin-bottom: 50px;
`

Details.SectionTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 30px;

  .green {
    color: ${colors.green};
  }
`

Details.Description = styled.div`
  background: ${colors.gray};
  padding: 40px 30px;

  ${down('sm')} {
    margin-left: -15px;
    margin-right: -15px;
    padding-left: 15px;
    padding-right: 15px;
  }

  img {
    max-width: 100%;
  }
`

Details.Youtube = styled(
  withInnerWrapper(Youtube, 'videoId')('div'),
)`
  position: relative;
  padding-top: 60%;

  > div {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    iframe {
      width: 100%;
      height: 100%;
    }
  }
`

export default Details
